import { InboundDeliveryFragment } from "../../models/autogenerated-deliveryService-gql/graphql";
import { IDeliveryItem } from "../../models/deliveryItem";
import { IDocument } from "../../models/document";
import { IGeneralInfo } from "../../models/generalInfo";
import { ISavedProgress } from "../../models/savedProgress";
import { mapToSavedProgress } from "../../utils/mapper";
import { initialSavedProgress } from "../OrderContext";

export enum SavedProgressReducerActionTypes {
  "SET_STATE" = "SET_STATE",
  "SET_PROP" = "SET_PROP",
  "RESET" = "RESET",
}

interface ISavedProgressActionPrefillState {
  type: SavedProgressReducerActionTypes.SET_STATE;
  value: InboundDeliveryFragment;
}

interface ISavedProgressActionSetGeneralInfo {
  type: SavedProgressReducerActionTypes.SET_PROP;
  property: "generalInfo";
  value: IGeneralInfo;
}

interface ISavedProgressActionSetDeliveryItems {
  type: SavedProgressReducerActionTypes.SET_PROP;
  property: "deliveryItems";
  value: IDeliveryItem[];
}

interface ISavedProgressActionSetPlannedArrival {
  type: SavedProgressReducerActionTypes.SET_PROP;
  property: "plannedDelivery";
  value: Date;
}

interface ISavedProgressActionSetDocumentItems {
  type: SavedProgressReducerActionTypes.SET_PROP;
  property: "documentItems";
  value: IDocument[];
}
interface ISavedProgressActionReset {
  type: SavedProgressReducerActionTypes.RESET;
}

export type ISavedProgressAction =
  | ISavedProgressActionPrefillState
  | ISavedProgressActionSetGeneralInfo
  | ISavedProgressActionSetDeliveryItems
  | ISavedProgressActionSetPlannedArrival
  | ISavedProgressActionSetDocumentItems
  | ISavedProgressActionReset;

export const savedProgressReducer = (
  state: ISavedProgress,
  action: ISavedProgressAction,
) => {
  switch (action.type) {
    case SavedProgressReducerActionTypes.SET_STATE:
      return mapToSavedProgress(action.value) ?? state;
    case SavedProgressReducerActionTypes.SET_PROP:
      return { ...state, [action.property]: action.value };
    case SavedProgressReducerActionTypes.RESET:
      return initialSavedProgress;
    default:
      return state;
  }
};
